import * as React from 'react';
import styled from 'styled-components';
import { colors } from '@omilia/theme';

import Button from '../Button';
import { getThemeProp } from 'styles/theme';
import IconSpinner from 'components/Icons/IconSpinner';
import { useTranslation } from '@omilia/providers';

const SErrorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

const SIcon = styled.i`
  display: inline-block;
  height: auto;
  margin-bottom: 16px;
  width: 68px;
`;

const STitle = styled.div`
  color: ${colors.COLOR_GREY_800};
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 47px;
`;

const SButton = styled(Button)`
  font-size: 15px;
  font-weight: 500;
  line-height: 23px;
  padding: 7px 22px;
`;

interface Prop {
  restartChat: () => void;
  isRetrying?: boolean;
  theme?: any;
}

const Error = ({ restartChat, isRetrying = false, theme = {} }: Prop) => {
  const { t } = useTranslation();
  return (
    <SErrorContainer>
      {isRetrying ? (
        <>
          <STitle>{t('errors.tryingToReconnect')}</STitle>
          <IconSpinner
            data-test="chat-content-spinner"
            color={getThemeProp('primaryColor', { theme })}
          />
        </>
      ) : (
        <>
          <SIcon
            dangerouslySetInnerHTML={{
              __html: require('!svg-inline-loader!assets/icons/error.svg'),
            }}
          />
          <STitle>{t('errors.somethingWentWrong')}</STitle>
          <SButton label={t('errors.restartDialog')} onClick={restartChat} />
        </>
      )}
    </SErrorContainer>
  );
};

export default Error;
